type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  id?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  id,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label tracking-widest uppercase text-primary-700">
        <i className="ri-subtract-line"></i>
        {eyebrow}
      </span>
      <h2
        id={id}
        className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug"
      >
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
          {desc}
        </p>
      )}
    </div>
  );
}